import _ from "lodash";
import { IGNORED_EXCEPTION_MESSAGES } from "./src/sharedErrorConstants";

const IGNORED_NETWORK_ERRORS = ["ERR_NETWORK", "ERR_CANCELED", "ECONNABORTED"];
const IGNORED_FETCH_ERROR_MESSAGES = ["Network request failed"];

const IGNORED_CHUNK_LOAD_ERROR_MESSAGES = [
  "Failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "Importing a module script failed",
  "Failed to load module script",
  "Unable to preload CSS",
];

export function sentryBeforeSend(event, hint) {
  const networkError = _.get(hint, "originalException.code");
  const exceptionMessage = _.get(hint, "originalException.message") || _.get(hint, "originalException.value");
  const isFetchNetworkError =
    _.get(hint, "originalException.name") === "TypeError" && IGNORED_FETCH_ERROR_MESSAGES.includes(exceptionMessage);
  if (
    IGNORED_NETWORK_ERRORS.includes(networkError) ||
    isFetchNetworkError ||
    _.get(hint, "originalException.status") == "401" ||
    (_.get(hint, "originalException.status") == "403" &&
      _.get(hint, "originalException.response.data.errorCode") === 1001)
  ) {
    return null;
  }

  const exceptions = _.get(event, "exception.values", []);
  const candidateMessages = [
    exceptionMessage,
    _.get(event, "message"),
    ..._.map(exceptions, (ex) => _.get(ex, "value")),
  ];
  const isIgnoredMessage = _.some(
    candidateMessages,
    (message) => _.isString(message) && _.some(IGNORED_EXCEPTION_MESSAGES, (ignored) => message.includes(ignored)),
  );
  if (isIgnoredMessage) {
    return null;
  }

  const originalException = _.get(hint, "originalException");
  if (
    _.isObject(originalException) &&
    Object.hasOwn(originalException, "scFunction") &&
    !globalThis.location.href.includes("designviewer")
  ) {
    return null;
  }

  const isChunkLoadError =
    _.some(IGNORED_CHUNK_LOAD_ERROR_MESSAGES, (msg) => _.includes(exceptionMessage, msg)) ||
    _.some(exceptions, (ex) =>
      _.some(IGNORED_CHUNK_LOAD_ERROR_MESSAGES, (msg) => _.includes(_.get(ex, "value", ""), msg)),
    );
  if (isChunkLoadError) {
    return null;
  }

  const isFabricSchedulerCrash = _.some(
    exceptions,
    (ex) =>
      _.get(ex, "type") === "EXC_BAD_ACCESS" &&
      _.some(
        _.get(ex, "stacktrace.frames", []),
        (frame) =>
          frame && frame.filename === "Scheduler.cpp" && _.includes(frame.function, "uiManagerDidFinishTransaction"),
      ),
  );
  if (isFabricSchedulerCrash) {
    return null;
  }

  return event;
}
